import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ProtectedRoute from "./routes/ProtectedRoute";
import AdminLoginPage from "./admin/pages/login/AdminLoginPage";
import AdminLayout from "./admin/components/layout/AdminLayout";
import CandidateListPage from "./admin/pages/candidates/CandidateListPage";
import EmployeeListPage from "./admin/pages/employees/EmployeeListPage";
import MonitoringPage from "./admin/pages/monitoring/MonitoringPage";


function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            /> 
      {/* Admin login */}
      <Route path="/admin" element={<AdminLoginPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />

      {/* Admin dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        {/* 👇 THESE MUST BE NESTED */}
        <Route index element={<h2>Welcome Admin</h2>} />
        <Route path="candidates" element={<CandidateListPage />} />
        <Route path="employees" element={<EmployeeListPage />} />
        <Route path="monitoring" element={<MonitoringPage />} />
      </Route>

      </Routes>
  );
}

export default App;
